// function initAutocomplete() {
//     const inputField = document.getElementById('address-input');
//     const resultsContainer = document.getElementById('autocomplete-results');

//     // Check if inputField and resultsContainer exist
//     if (!inputField || !resultsContainer) {
//         console.error('Required DOM elements not found. Ensure the IDs "address-input" and "autocomplete-results" exist.');
//         return;
//     }

//     // Initialize the AutocompleteService
//     autocompleteService = new google.maps.places.AutocompleteService();

//     // Add input event listener to fetch predictions
//     inputField.addEventListener('input', function () {
//         const input = inputField.value;

//         if (input) {
//             autocompleteService.getPlacePredictions(
//                 { input, componentRestrictions: { country: 'au' } },
//                 displayResults
//             );
//         } else {
//             resultsContainer.innerHTML = '';
//             resultsContainer.style.display = 'none'; // Hide when no input
//         }
//     });
// }

function initAutocomplete() {
    const inputField = document.getElementById('address-input');
    const resultsContainer = document.getElementById('autocomplete-results');

    if (!inputField || !resultsContainer) {
        console.error('Required DOM elements not found. Ensure the IDs "address-input" and "autocomplete-results" exist.');
        return;
    }

    let debounceTimeout;
    const debounceDelay = 300; // milliseconds
    const minCharacters = 5;

    autocompleteService = new google.maps.places.AutocompleteService();
    // autocompleteService = new google.maps.places.AutocompleteSuggestion();

    // AutocompleteSuggestion.fetchAutocompleteSuggestions

    inputField.addEventListener('input', function () {
        const input = inputField.value;

        clearTimeout(debounceTimeout);

        if (input.length < minCharacters) {
            resultsContainer.innerHTML = '';
            resultsContainer.style.display = 'none';
            return;
        }

        debounceTimeout = setTimeout(() => {
            autocompleteService.getPlacePredictions(
             // autocompleteService.fetchAutocompleteSuggestions(
                {
                    input,
                    componentRestrictions: { country: 'au' }
                },
                displayResults
            );
        }, debounceDelay);
    });
}

// async function initAutocomplete() {
//     const inputField = document.getElementById('address-input');
//     const resultsContainer = document.getElementById('autocomplete-results');

//     if (!inputField || !resultsContainer) {
//         console.error('Required DOM elements not found. Ensure the IDs "address-input" and "autocomplete-results" exist.');
//         return;
//     }

//     let debounceTimeout;
//     const debounceDelay = 300;
//     const minCharacters = 5;
//     const sessionToken = new google.maps.places.AutocompleteSessionToken();

//     inputField.addEventListener('input', function () {
//         const input = inputField.value.trim();

//         clearTimeout(debounceTimeout);

//         if (input.length < minCharacters) {
//             resultsContainer.innerHTML = '';
//             resultsContainer.style.display = 'none';
//             return;
//         }

//         debounceTimeout = setTimeout(async () => {
//             try {
//                 const request = {
//                   input: input,
//                   sessionToken: sessionToken,
//                   locationBias: {
//                     west: 112.9211,
//                     south: -43.7405,
//                     east: 153.6383,
//                     north: -10.6840,
//                   }
//                 };


//                 const { suggestions } =
//                     await google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions(request);

//                 displayResults(suggestions);
//             } catch (error) {
//                 console.error('Error fetching suggestions:', error);
//                 resultsContainer.innerHTML = '<li>Error retrieving suggestions.</li>';
//                 resultsContainer.style.display = 'block';
//             }
//         }, debounceDelay);
//     });

// }

//   function displayResults(suggestions) {
//     const inputField = document.getElementById('address-input');
//     const resultsContainer = document.getElementById('autocomplete-results');

//     if (!inputField || !resultsContainer) {
//         console.error('Required DOM elements not found. Ensure the IDs "address-input" and "autocomplete-results" exist.');
//         return;
//     }

//     if (!suggestions || suggestions.length === 0) {
//         resultsContainer.innerHTML = '';
//         resultsContainer.style.display = 'none';
//         return;
//     }

//     resultsContainer.innerHTML = '';
//     resultsContainer.style.display = 'block';

//     suggestions.forEach((suggestion) => {
//         const placePrediction = suggestion.placePrediction;
//         const resultItem = document.createElement('div');
//         resultItem.classList.add('autocomplete-result');
//         resultItem.textContent = placePrediction.text.text;

//         resultItem.addEventListener('click', async () => {
//             inputField.value = placePrediction.text.text;
//             resultsContainer.innerHTML = '';
//             resultsContainer.style.display = 'none';

//             try {
//                 const place = await placePrediction.toPlace();
//                 await place.fetchFields({ fields: ['addressComponents'] });
//                 displayAddressDetails({ address_components: place.addressComponents });
//             } catch (error) {
//                 console.error('Failed to fetch place details:', error);
//             }
//         });

//         resultsContainer.appendChild(resultItem);
//     });
// }






function displayResults(predictions, status) {
    const inputField = document.getElementById('address-input');
    const resultsContainer = document.getElementById('autocomplete-results');

    // Check if inputField and resultsContainer exist
    if (!inputField || !resultsContainer) {
        console.error('Required DOM elements not found. Ensure the IDs "address-input" and "autocomplete-results" exist.');
        return;
    }

    if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
        resultsContainer.innerHTML = '';
        resultsContainer.style.display = 'none'; // Hide when no results
        return;
    }

    resultsContainer.innerHTML = ''; // Clear previous results
    resultsContainer.style.display = 'block'; // Show the results container

    predictions.forEach((prediction) => {
        const resultItem = document.createElement('div');
        resultItem.classList.add('autocomplete-result');
        resultItem.textContent = prediction.description;

        // On result click, fetch and display the address components
        resultItem.addEventListener('click', () => {
            inputField.value = prediction.description;
            resultsContainer.innerHTML = ''; // Clear results after selection
            resultsContainer.style.display = 'none'; // Hide the container

            // Use PlacesService to get detailed address components
            const placesService = new google.maps.places.PlacesService(inputField);
            placesService.getDetails({ placeId: prediction.place_id }, (place, status) => {
                if (status === google.maps.places.PlacesServiceStatus.OK) {
                    displayAddressDetails(place);
                }
            });
        });

        resultsContainer.appendChild(resultItem);
    });
}

  // Display the selected address details
  function displayAddressDetails(place) {
      let streetField = document.getElementById('street');
      let suburbField = document.getElementById('suburb');
      let stateField = document.getElementById('state');
      let postcodeField = document.getElementById('postcode');
    
       let unitnumber = '', streetnumber = '', street = '', suburb = '', state = '', postcode = '';

      place.address_components.forEach((component) => {
          const types = component.types;

          if (types.includes('subpremise')) {
            unitnumber = component.long_name;
          }

          if (types.includes('street_number')) {
            streetnumber = component.long_name;
          }

          if (types.includes('route')) {
              street = component.long_name;
          }

          if (types.includes('locality')) {
              suburb = component.long_name;
          }

          if (types.includes('administrative_area_level_1')) {
              state = component.short_name;
          }

          if (types.includes('postal_code')) {
              postcode = component.long_name;
          }
      });

      const fullStreet = `${unitnumber ? unitnumber + '/' : ''}${streetnumber} ${street}`.trim();

      console.log(fullStreet);

      // Update the HTML content with the selected address details
      streetField.textContent = fullStreet;
      suburbField.textContent = suburb;
      stateField.textContent = state;
      postcodeField.textContent = postcode;

      // Show the address details section
      // addressDetails.style.display = 'block';

    // Call the function to post the suburb and postcode
  postAddressDetails(suburb, postcode);
  }

console.log('pre POST');

  function postAddressDetails(suburb, postcode) {
    // Retrieve address details
    const token = document.getElementById('cart-unique').textContent;
    const street = document.getElementById('street').textContent;
    const suburbValue = document.getElementById('suburb').textContent;
    const state = document.getElementById('state').textContent;
    const postcodeValue = document.getElementById('postcode').textContent;

    if (token.length < 1) {
      // fetchCartDetailsAndUpdateUI();
      fetchCartTokenWithRetry();
      console.log('token is empty');
      const token = document.getElementById('cart-unique').textContent;
      console.log("Token retry:", token);
    } 
    else {
    console.log("Token:", token);
    }
    
    const buttonContainer = document.getElementById('button-container');
    const loadingIndicator = document.getElementById('loading-indicator'); // Loading element
    const url = 'https://shipping.pistachiopapi.com.au/check-service';

    const currentDatetime = new Date();
    const formattedDatetime = currentDatetime.toISOString().slice(0, 19).replace("T", " ");
    console.log(formattedDatetime);

    console.log(street);

    // Prepare data for POST request
    const data = {
        street: street.trim(),
        suburb: suburbValue.trim(),
        state: state.trim(),
        postcode: postcodeValue.trim(),
        token: token.trim(),
        date: formattedDatetime,
        delivery: 'placeholder'
    };

    console.log(data);

    // Show the loading indicator
    if (loadingIndicator) {
        loadingIndicator.style.display = 'flex';
    }

    // Perform the fetch request
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(json => {
        // Hide the loading indicator
        if (loadingIndicator) {
            loadingIndicator.style.display = 'none';
        }

        // Update the button container with the response HTML
        buttonContainer.innerHTML = json['html'];

        // Reinitialize button toggle functionality
        initButtonToggle();

        // Show cart footer for checkout if area is serviceable
        if (json['html'] && json['html'].includes('Sorry, delivery is not available for this location')) {
          console.log('Delivery unavailable for this location');
        }
        else {
          const checkOut = document.getElementById('cart-footer');
          if (checkOut) {
              checkOut.style.display = 'block';
          }
        }
        
    })
    .catch(error => {
        // Hide the loading indicator
        if (loadingIndicator) {
            loadingIndicator.style.display = 'none';
        }

        console.error('Error:', error);
        responseContainer.textContent = 'An error occurred: ' + error.message;
    });
}


// Function to initialize button toggle functionality
function initButtonToggle() {
    const buttonContainer = document.getElementById('button-container');
    
    // Check if buttonContainer exists
    if (!buttonContainer) {
        return; // Exit if button container is not found
    }

    // Select all date buttons
    const dateButtons = buttonContainer.querySelectorAll('.date-button');

    // Check if there are any date buttons to work with
    if (dateButtons.length === 0) {
        return; // Exit if no date buttons are found
    }

    // Add click event to each date button
    dateButtons.forEach(button => {
        button.addEventListener('click', () => {
            // Remove 'selected' class from all date buttons and hide all timeslot divs
            dateButtons.forEach(btn => {
                btn.classList.remove('selected');
                const timeslotDiv = btn.nextElementSibling;
                if (timeslotDiv) {
                    timeslotDiv.style.display = 'none';
                    // Remove 'selected' class from all timeslot buttons
                    timeslotDiv.querySelectorAll('button').forEach(timeslotButton => {
                        timeslotButton.classList.remove('selected');
                    });
                }
            });

            // Toggle the display of the clicked date button's timeslot div
            const timeslotDiv = button.nextElementSibling; // Get the next sibling div (timeslot)
            if (timeslotDiv) {
                if (timeslotDiv.style.display === 'none' || timeslotDiv.style.display === '') {
                    timeslotDiv.style.display = 'flex'; // Show timeslot
                    button.classList.add('selected'); // Add selected class to date button
                } else {
                    timeslotDiv.style.display = 'none'; // Hide timeslot
                    button.classList.remove('selected'); // Remove selected class from date button
                }
            }
        });
    });

    // Add event listener to timeslot buttons
    const timeslotButtons = buttonContainer.querySelectorAll('.timeslot button');
    
    // Check if there are any timeslot buttons to work with
    if (timeslotButtons.length === 0) {
        return; // Exit if no timeslot buttons are found
    }

    timeslotButtons.forEach(timeslotButton => {
        timeslotButton.addEventListener('click', () => {
            // Remove 'selected' class from all date and timeslot buttons
            dateButtons.forEach(btn => btn.classList.remove('selected'));
            timeslotButtons.forEach(btn => btn.classList.remove('selected'));

            // Add 'selected' class to clicked timeslot button and its corresponding date button
            timeslotButton.classList.add('selected');
            const correspondingDateButton = timeslotButton.closest('.timeslot').previousElementSibling;
            correspondingDateButton.classList.add('selected');

            // Get data-date and data-timeslot from the clicked button
            const selectedDate = timeslotButton.getAttribute('data-date');
            const selectedTimeslot = timeslotButton.getAttribute('data-timeslot');

            // Format the string
            const formattedTimeslot = `${selectedTimeslot}`;

            // Prepare the note content
            const noteContent = `Selected Date: ${selectedDate}, Timeslot: ${formattedTimeslot}`;

            // Get cart Token
            const token = document.getElementById('cart-unique');
            
            // Get address
            const street = document.getElementById('streetField').textContent.trim();
            const suburb = document.getElementById('suburbField').textContent.trim();
            const state = document.getElementById('stateField').textContent.trim();
            const postcode = document.getElementById('postcodeField').textContent.trim();
            const addressData = {
                street,
                suburb,
                state,
                postcode
            };

            // Get the current date and time
            const currentDatetime = new Date().toISOString(); // ISO 8601 format
            console.log(currentDatetime);
            
            // Constructing the JSON payload
            const payload = {
                note: noteContent,
                addressData,
                token,
                datetime: currentDatetime
            };
          
            // Stringifying the JSON payload
            const bodyContent = JSON.stringify(payload);

            // Send data to external endpoint
            fetch('https://shipping.pistachiopapi.com.au/cart', {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json',
                      'Accept': 'application/json',
                  },
                  body: bodyContent
              })
              .then(response => {
                  if (!response.ok) {
                      throw new Error('Network response was not ok');
                  }
                  return response.json();
              })
              .then(data => {
                  // Handle the response if necessary
                  console.log('Data sent successfully:', data);
              })
              .catch(error => {
                  console.error('There was a problem with the fetch operation:', error);
              });
        });
    });
}

// Call the function to initialize the functionality
initButtonToggle();

// Initialize the button toggle functionality on page load
document.addEventListener('DOMContentLoaded', initButtonToggle);

// Initialize custom autocomplete on window load
window.onload = initAutocomplete;

setInterval(initAutocomplete, 800);

// Polling function to wait for a valid cart token
async function fetchCartTokenWithRetry(retries = 5, delay = 500) {
    for (let i = 0; i < retries; i++) {
        try {
            const response = await fetch('/cart.js', {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            });

            if (!response.ok) {
                throw new Error(`Error fetching cart: ${response.statusText}`);
            }

            const cartData = await response.json();
            const cartId = cartData.token;

            if (cartId) {
                // Update the HTML element with the latest cart token
                const cartUniqueElement = document.getElementById('cart-unique');
                if (cartUniqueElement) {
                    cartUniqueElement.textContent = cartId;
                } else {
                    console.warn('Element with ID "cart-unique" not found.');
                }
                return cartId; // Return the valid token
            }

            console.warn(`Token not found. Retry ${i + 1}/${retries}`);
        } catch (error) {
            console.error('Error fetching cart token:', error);
        }

        // Wait before retrying
        await new Promise((resolve) => setTimeout(resolve, delay));
    }

    throw new Error('Failed to fetch valid cart token after retries.');
}

// Function to handle cart updates dynamically
async function handleCartUpdates() {
    try {
        const token = await fetchCartTokenWithRetry(); // Ensure a valid token is retrieved
        console.log('Cart token updated:', token);
    } catch (error) {
        console.error('Error updating cart token:', error);
    }
}

// Attach cart update listener
function attachCartUpdateListener() {
    document.addEventListener('cart:updated', handleCartUpdates); // Listen for custom cart update events

    // Fallback: Monitor cart changes periodically if no events are available
    let lastToken = null;
    setInterval(async () => {
        const cartUniqueElement = document.getElementById('cart-unique');
        const currentToken = cartUniqueElement ? cartUniqueElement.textContent.trim() : '';
        if (!currentToken || currentToken !== lastToken) {
            lastToken = await fetchCartTokenWithRetry(); // Refresh the token
        }
    }, 1000); // Check every second
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
    attachCartUpdateListener();
    handleCartUpdates(); // Fetch token on initial load
});



